module.exports = __webpack_public_path__ + "static/media/trigger_soundi 7-2-Audio 1.5ef8c4f2.mp3";